module.exports = __webpack_public_path__ + "img/cards.db70ddb1.svg";